import { render, staticRenderFns } from "./service_info.vue?vue&type=template&id=1127d204&scoped=true&"
import script from "./service_info.vue?vue&type=script&lang=js&"
export * from "./service_info.vue?vue&type=script&lang=js&"
import style0 from "./service_info.vue?vue&type=style&index=0&id=1127d204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127d204",
  null
  
)

export default component.exports